export const LOCAL_STORAGE_NAME = 'crtusr'

export const USER_FABIEN = 'fabien.webdev@gmail.com'
export const USER_MAINA = 'myna@mynatime.me'

export const MAINA_BANK_ACCOUNTS = [
  {
    bankName: 'PayPay銀行 普通',
    bankOffice: '005',
    accountNumber: '3894871',
    furigana: 'マイナ',
    name: 'Myna'
  },
  {
    bankName: '三菱UFJ銀行 普通',
    bankOffice: '藤ヶ丘支店',
    accountNumber: '0196126',
    furigana: 'ドボード マイナ',
    name: 'ドボード 舞奈',
    comment: ''
  }
]

export const FABIEN_BANK_ACCOUNTS = [
  {
    bankName: '三菱UFJ銀行 普通',
    bankOffice: '多治見支店',
    accountNumber: '0373376',
    furigana: 'ドボード ファビアン レミ',
    name: 'DEBORDE FABIEN REMI',
    comment: ''
  }
]

export const MAINA_INFO = {
  image: 'data:image/png;base64,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',
  address: '愛知県名古屋市北区杉村1-7-6',
  phone: '080-9489-2100',
  mailAddress: 'myna@mynatime.me'
}

export const FABIEN_INFO = {
  image: null,
  address: '11 chemin du pèlerin, \n17460 Préguillac, France',
  phone: '+33-6-5673-2918',
  mailAddress: 'fabien.webdev@gmail.com'
}

export const TAX = 0.1

export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
}

export const DOCUMENT_TYPE = {
  estimate: 0,
  invoice: 1,
  delivery: 2,
  payment: 3
}

export const COLLECTIONS = {
  documents: 'documents'
}
